/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import { Component, ContentChild, ContentChildren, Input, QueryList } from '@angular/core';
import { FeCheckbox } from '../form-elements/fe-checkbox/fe-checkbox';
import { FeText } from '../form-elements/fe-text/fe-text';
import { FeSwitcher } from '../form-elements/fe-switcher/fe-switcher';
import { FeRadioGroup } from '../form-elements/fe-radio-group/fe-radio-group';
import { FeRadio } from '../form-elements/fe-radio/fe-radio';
import { FeButton } from '../form-elements/fe-button/fe-button';
import { FeSelect } from '../form-elements/fe-select/fe-select';
import { CagefsComponent } from '../../../cagefs-plugin/cagefs.component';
import { NodeJSIndexComponent } from '../../../nodejs/index.component';
import { UiFormGroup } from '../ui-form-group/ui-form-group';
import { Mixin } from '../../mixins/Mixin';
import { Filterable } from '../../mixins/Filterable';

@Component({
    selector: 'ui-accordion-group',
    template: require('./ui-accordion-group.html'),
    styles: [require('./ui-accordion-group.less')],
})
@Mixin([Filterable])
export class UiAccordionGroup {

    @ContentChildren(FeText) feTextList: QueryList<FeText>;
    @ContentChildren(FeCheckbox) feCheckboxList: QueryList<FeCheckbox>;
    @ContentChildren(FeRadio) feRadioList: QueryList<FeRadio>;
    @ContentChildren(FeRadioGroup) feRadioGroupList: QueryList<FeRadioGroup>;
    @ContentChildren(FeButton) feButtonList: QueryList<FeButton>;
    @ContentChildren(FeSwitcher) feSwitcherList: QueryList<FeSwitcher>;
    @ContentChildren(FeSelect) feSelectList: QueryList<FeSelect>;
    @ContentChildren(UiFormGroup) uiFormGroupList: QueryList<UiFormGroup>;
    @ContentChild(CagefsComponent) cagefsComponent: CagefsComponent;
    @ContentChild(NodeJSIndexComponent) nodejsComponent: NodeJSIndexComponent;

    public open: boolean = false;
    @Input() public hidden: boolean = false;
    @Input() public id: string = '';

    @Input() public title: string;

    @Input() highlightPhrase: string = '';

    filterByText: (text: string) => void;
    numFound: number = 0;

    private _title: string = '';

    public toggleSlide() {
        this.open = !this.open;
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/ui-accordion-group/ui-accordion-group.ts